<div class="panel-header {{hoverStyled}} {{clickStyled}}" [style.height]="height" (click)="onRedirectionUrl()">
    <span class="panel-header__title {{dotStyled}}">{{title}}</span>

    <div class="panel-header__main">
        <ng-content></ng-content>
    </div>    
</div>
